import * as React from 'react'
import {connect} from "react-redux"
import {Employee} from "../../models/Employee"
import {ApplicationState} from "../../store"
import {EmployeeList}  from '../components/EmployeeList'
import {ColumnData} from '../../models/ColumnData'
import {TabsService} from '../TabsService'
import {Tab, TabTypes} from '../Tab'
import {actionEmployeeFetchAll, actionEmployeeDelete, actionDeleteEmployees} from '../../store/employees/actions'
import {Button} from "@material-ui/core"
import AddIcon from "@material-ui/icons/AddCircleOutlineRounded"
import {t} from "../../core/localization"

export interface EmployeesTabProps {
	employees: Employee[]
	tab: Tab
}

export interface EmployeesTabState {
}

function mapStateToProps(state: ApplicationState) {
	return {
		employees: state.employees.list,
		tab: state.tabs.active
	}
}

class EmployeesTab extends React.Component<EmployeesTabProps, EmployeesTabState> {

	constructor(props: EmployeesTabProps) {
		super(props)
	}

	componentWillMount() {
	}

	componentWillReceiveProps(nextProps: EmployeesTabProps) {
	}

	componentDidMount() {
		actionEmployeeFetchAll()
	}

	onOpenClick(employee: Employee){
		TabsService.createTab(t.Employee + ': ' + employee.firstName + ' ' + employee.lastName, TabTypes.EMPLOYEES_NEW, employee)
	}
	
	onCopyClick(employee: Employee){
		TabsService.createTab(t.Employee + ': ' + employee.firstName + ' ' + employee.lastName, TabTypes.EMPLOYEES_NEW, { ...employee, id: null })
	}
	
	onDeleteClick(employee: Employee){
		actionEmployeeDelete(employee);
	}

	onActionDeleteClick(employees: Employee[]){
		actionDeleteEmployees(employees);
	}

	render(): React.ReactNode {

		const {employees} = this.props;
		
		const columns = [
			new ColumnData(t.FirstName, "firstName"),
			new ColumnData(t.LastName, "lastName"),
			new ColumnData(t.Position, "positionId")
		];

		return (
			<div style={{padding: '10px'}}>
				<div style={{marginBottom: '10px'}}><Button onClick={this.onNewClick} color="primary" style={{}}><AddIcon />{t.CreateNewEmployee}</Button></div>
				<EmployeeList
					columns={columns}
					items={employees}
					title={t.Employee}
					onOpenClick={(employee: Employee) => this.onOpenClick(employee)}
					onCopyClick={(employee: Employee) => this.onCopyClick(employee)}
					onDeleteClick={(employee: Employee) => this.onDeleteClick(employee)}
					onActionDeleteClick={(employees: Employee[]) => this.onActionDeleteClick(employees)}
					tab={this.props.tab}
				/>
			</div>
		)
	}

	onNewClick() {
		TabsService.createTab(t.NewEmployee, TabTypes.EMPLOYEES_NEW, new Employee())
	}
}

export default connect(mapStateToProps)(EmployeesTab);
